import { Breadcrumb } from '@sentry/react';
import DOMPurify from 'dompurify';
import { Log } from '../../../../sentry';

export const sanitizeLogger = (breadcrumb: Breadcrumb) => {
	Log({ category: 'SanitizeHTMLError', level: 'warning', ...breadcrumb });
};

export const getRemoveBreadcrumb = (
	element: DOMPurify.RemovedElement | DOMPurify.RemovedAttribute,
	html: string
): Breadcrumb => {
	if ('attribute' in element) {
		return {
			message: 'Removed unsafe attribute',
			data: {
				tag: element.from?.nodeName?.toLocaleLowerCase() || '',
				attr: element.attribute?.name?.toLocaleLowerCase() || '',
				value: element.attribute?.value || '',
				html: html.slice(0, 150)
			}
		};
	} else {
		return {
			message: 'Removed unsafe tag',
			data: {
				tag: element.element?.nodeName?.toLocaleLowerCase() || '',
				html: html.slice(0, 150)
			}
		};
	}
};

export const getSanitizeStyleBreadcrumb = (
	value: string,
	type: 'property' | 'value' | 'url' | 'rule' | 'parse',
	style: string
): Breadcrumb => {
	if (type === 'parse') {
		return {
			message: 'Parsing error',
			data: {
				style,
				error: value
			}
		};
	}

	return {
		message: `Sanitize unsafe ${type}`,
		data: {
			[type]: value,
			style
		}
	};
};
